import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function StoreInformation() {

	const { order } = useContext(RetailOrderContext);

	const store = useGetCompany(order.details.dealerCompanyID);

	return (
		<span className='store-information'>
			{store.data?.companyName}, {store.data?.PA_Address1}{!!store.data?.PA_Address2 && ' ' + store.data?.PA_Address2}, {order.details.dealerNumber}
		</span>
	);
}
